import * as React from 'react';

export function IconError() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path fill="#fff" fillOpacity=".01" d="M0 0h20v20H0z" />
      <path
        fill="#FF2D6B"
        fillRule="evenodd"
        d="M9.152 3.357a1 1 0 011.696 0l8.196 13.113a1 1 0 01-.848 1.53H1.804a1 1 0 01-.848-1.53L9.152 3.357z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M9.355 12.28l-.187-2.807a20.89 20.89 0 01-.053-1.178c0-.324.084-.576.252-.756a.88.88 0 01.674-.275c.336 0 .56.117.674.351.113.23.17.565.17 1.002 0 .258-.014.52-.041.785l-.252 2.889c-.027.344-.086.607-.176.791a.46.46 0 01-.445.275c-.211 0-.358-.087-.44-.263-.082-.18-.14-.451-.176-.815zm.65 3.855a.94.94 0 01-.626-.229c-.176-.156-.264-.373-.264-.65 0-.242.084-.447.252-.615a.854.854 0 01.627-.258c.246 0 .455.086.627.258a.819.819 0 01.264.615c0 .273-.088.488-.264.644a.897.897 0 01-.615.235z"
      />
    </svg>
  );
}
